// extracted by mini-css-extract-plugin
export default {"section__dark":"Section_section__dark__CBkMJ","section__light":"Section_section__light__d4aAB","section_title":"Section_section_title__Khiss"};